import { Link } from 'react-router-dom'

const OPEN_SIGNUP = import.meta.env.VITE_OPEN_SIGNUP !== 'false'

const STEPS = [
  {
    step: '01',
    title: 'Create your household',
    desc: 'Sign up in seconds. Name your household and you\'re in. No credit card needed for the free plan.',
  },
  {
    step: '02',
    title: 'Invite your people',
    desc: 'Send invite links to family members. They join with a tap — each gets their own color on the calendar.',
  },
  {
    step: '03',
    title: 'Add what matters',
    desc: 'Drop in events, chores, shopping lists, and meals. Everything syncs instantly across every device.',
  },
  {
    step: '04',
    title: 'Stay in sync',
    desc: 'Everyone sees the same picture. Get notified when plans change. Works offline when you\'re out of signal.',
  },
]

export const HowItWorksSection = () => (
  <section id="how-it-works" className="py-24 px-4 bg-primary-light">
    <div className="max-w-5xl mx-auto">
      <div className="text-center mb-16 reveal">
        <p className="text-primary text-sm font-semibold uppercase tracking-wider mb-3">Getting started</p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-text-primary mb-4">
          Up and running in minutes
        </h2>
        <p className="text-text-secondary max-w-xl mx-auto">
          No tutorials needed. DoorChart is built to be simple enough that the whole family actually uses it.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map(({ step, title, desc }, i) => (
          <div
            key={step}
            className="reveal relative bg-white rounded-2xl border border-border p-6 shadow-sm"
            style={{ transitionDelay: `${i * 100}ms` }}
          >
            {i < STEPS.length - 1 && (
              <div className="hidden lg:block absolute top-8 -right-3 w-6 h-px bg-border z-10" />
            )}
            <div className="font-display text-4xl font-bold text-primary/15 mb-4">{step}</div>
            <h3 className="font-semibold text-text-primary mb-2">{title}</h3>
            <p className="text-sm text-text-secondary leading-relaxed">{desc}</p>
          </div>
        ))}
      </div>

      <div className="text-center mt-12 reveal">
        {OPEN_SIGNUP ? (
          <Link
            to="/signup"
            className="inline-block bg-primary text-white text-sm font-semibold px-8 py-4 rounded-2xl hover:bg-primary/90 transition-all shadow-xl shadow-primary/20"
          >
            Get started free →
          </Link>
        ) : (
          <a
            href="#waitlist"
            className="inline-block bg-primary text-white text-sm font-semibold px-8 py-4 rounded-2xl hover:bg-primary/90 transition-all shadow-xl shadow-primary/20"
          >
            Join the waitlist →
          </a>
        )}
      </div>
    </div>
  </section>
)
